import {createFileRoute} from '@tanstack/react-router';

import PatientAuditLog from '@/patient/views/user/AuditLog';
import PractitionerAuditLog from '@/practitioner/views/user/AuditLog';
import {useIsPatient} from '@/shared/contexts/UserContext/useUserContext';

function AuditLogWrapper() {
  const isPatient = useIsPatient();
  return isPatient ? <PatientAuditLog /> : <PractitionerAuditLog />;
}

export const Route = createFileRoute('/(shared)/audit-log')({
  component: AuditLogWrapper
});
